<template>
  <div>
    <a-button
      type="primary"
      @click="goToCreateSynchronization"
      class="create-synchronization-button"
    >
      <a-icon type="plus" />
      {{ $t("synchronization.create_synchronization") }}
    </a-button>
    <SyncListTable />
  </div>
</template>

<script lang="ts">
export default {
  metaInfo() {
    return {
      titleTemplate: `%s - ${this.$t("synchronization.title")}`
    }
  }
}
</script>

<script setup lang="ts">
import { onBeforeUnmount, onMounted } from "vue"
import { useRouter } from "vue-router/composables"

import SyncListTable from "@/modules/sync/_components/SyncListTable.vue"
import { useSyncListStore } from "@/modules/sync/store/useSyncListStore"

// Store & Route
const syncListStore = useSyncListStore()
const router = useRouter()
// End Store & Route

// Methods
const goToCreateSynchronization = () => {
  router.push({ name: "sync-create" })
}
// End Methods

// Lifecycle
onMounted(() => {
  syncListStore.getSynchronizations().then((data) => {
    syncListStore.getSyncDraftsMeta(data.results.map((sync) => sync.uuid))
  })
})
onBeforeUnmount(() => {
  syncListStore.stopTaskPolling()
})
// End Lifecycle
</script>

<style lang="scss" scoped>
.create-synchronization-button {
  margin-bottom: 24px;
}
</style>
